import { render, staticRenderFns } from "./index-shopList.vue?vue&type=template&id=fd42d3ee&scoped=true"
import script from "./index-shopList.vue?vue&type=script&lang=js"
export * from "./index-shopList.vue?vue&type=script&lang=js"
import style0 from "./index-shopList.vue?vue&type=style&index=0&id=fd42d3ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd42d3ee",
  null
  
)

export default component.exports